import type { ImportJob, Source } from '@casetrace/shared';
import { JOB_STATUS_LABEL, uploadSummary } from './sources-panel-helpers';
import { SourceTypeIcon } from './source-type-icon';

type JobsListSectionProps = {
  readonly jobs: ImportJob[];
  readonly sourcesById: ReadonlyMap<string, Source>;
  readonly isLoading: boolean;
};

export function JobsListSection({ jobs, sourcesById, isLoading }: JobsListSectionProps) {
  return (
    <section>
      <h3 className="text-xs font-medium uppercase tracking-wide text-[#5e6070]">
        Siste importjobber
      </h3>
      {isLoading && <p className="mt-2 text-xs text-[#5e6070]">Laster importjobber...</p>}
      {!isLoading && jobs.length === 0 && (
        <p className="mt-2 text-xs text-[#5e6070]">Ingen jobber startet enda.</p>
      )}
      <div className="mt-2 flex flex-col gap-2">
        {jobs.map((job) => {
          const source = sourcesById.get(job.sourceId);
          return (
            <div
              key={job.id}
              className="rounded-md border px-3 py-2 text-xs"
              style={{ borderColor: 'rgba(255,255,255,0.08)' }}
            >
              <p className="font-medium text-[#ededf0]">{JOB_STATUS_LABEL[job.status]}</p>
              <p className="flex items-center gap-2 text-[#5e6070]">
                {source ? <SourceTypeIcon type={source.type} className="shrink-0" /> : null}
                Kilde: {source?.navn ?? job.sourceId}
              </p>
              {source && (
                <p className="text-[#5e6070]">{uploadSummary(source) ?? 'Opplasting registrert'}</p>
              )}
              {typeof job.progress === 'number' && (
                <p className="text-[#5e6070]">Fremdrift: {job.progress}%</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
